import "./style.css";
import CarteProps from "./CarteProps";

const Carte = (props: CarteProps) => (
  <div className={"card-conteneur"}>{props.children}</div>
);

export default Carte;
